import React from 'react';
import { Eyebrow } from './ui/Eyebrow';
import { systemStats, tracks } from '../data/content';
export function SystemSection() {
  return <section className="border-b border-ink/40 bg-ink text-cream" data-id="element-219" data-mp="3gihmzffvbqpf">
      <div className="mx-auto max-w-6xl px-5 py-20 lg:py-24" data-id="element-220" data-mp="3bi3p2q7zdx54">
        <div className="grid gap-14 lg:grid-cols-[1.1fr_0.9fr] lg:gap-20" data-id="element-221" data-mp="3bkpuaj7eg0k6">
          <div data-id="element-222" data-mp="36jk4at54irec">
            <Eyebrow tone="light" data-id="element-223" data-mp="36m68qjwpwqsc">El sistema más completo para profes de guitarra</Eyebrow>
            <h2 className="mt-4 font-condensed text-5xl uppercase leading-[0.92] tracking-tight sm:text-6xl" data-id="element-224" data-mp="31mtpe95221ui">
              El Profe de <span className="text-amber" data-id="element-225" data-mp="2ssf1ji6glizs">Guitarra</span>
            </h2>
            <p className="mt-5 font-display text-xl italic leading-snug text-cream/80 sm:text-2xl" data-id="element-226" data-mp="2sqayt3kaqq13">
              El sistema de enseñanza «anti-abandono» en 6 volúmenes.
            </p>
            <p className="mt-6 max-w-prose text-[15px] leading-relaxed text-cream/75" data-id="element-227" data-mp="2itg0ako0wpmt">
              Más de 300 páginas con rutinas semana a semana, ejercicios de digitación, púa
              alternada, ritmo, ligados, slides y resistencia. No es un libro de teoría: es una caja
              de herramientas técnica, ya preparada para vos.
            </p>
            <p className="mt-4 max-w-prose text-[15px] leading-relaxed text-cream/75" data-id="element-228" data-mp="u1ti9d6ac3z7">
              Todo se entrega en PDF listo para imprimir y llega a tu email. Sin videos, sin
              audiolibros, sin plataformas donde loguearte.
            </p>
          </div>

          <dl className="grid grid-cols-2 gap-px overflow-hidden rounded-xl bg-cream/15" data-id="element-229" data-mp="1roshnvod3q0s">
            {systemStats.map(stat => <div key={stat.label} className="bg-ink px-6 py-8" data-id="element-230" data-mp="1cs1gphz1i692">
                <dt className="text-[10px] font-semibold uppercase tracking-eyebrow text-cream/50" data-id="element-231" data-mp="1ctmerhkkc7bo">
                  {stat.label}
                </dt>
                <dd className="mt-3 font-display text-4xl font-semibold leading-none text-cream" data-id="element-232" data-mp="1bbhwjwy4gph">
                  {stat.value}
                </dd>
              </div>)}
          </dl>
        </div>

        <div className="mt-16 border-t border-cream/15 pt-10" data-id="element-233" data-mp="28yedxns5ntz5">
          <div className="flex flex-col gap-2 sm:flex-row sm:items-baseline sm:justify-between" data-id="element-234" data-mp="23z1n6ry5y2ra">
            <Eyebrow tone="light" data-id="element-235" data-mp="1z8bkjmh4ge0a">Cobertura total</Eyebrow>
            <p className="text-[13px] text-cream/70" data-id="element-236" data-mp="1z6qo1rb8ykzs">
              De principiante a avanzado · Niños, adolescentes y adultos
            </p>
          </div>

          <ol className="mt-8 grid gap-x-8 gap-y-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-237" data-mp="1pancjuui9a06">
            {tracks.map(track => <li key={track.number} className="flex items-baseline gap-4 border-b border-cream/10 pb-4" data-id="element-238" data-mp="1l80pe78s4d9b">
                <span className="font-display text-lg text-amber" data-id="element-239" data-mp="1g8nwp5v88byt">{track.number}</span>
                <span className="text-[15px] text-cream/90" data-id="element-240" data-mp="1baw224376bqx">{track.label}</span>
              </li>)}
          </ol>
        </div>
      </div>
    </section>;
}